import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal, Overline } from "./Reveal";

const CAPS = [
  "Conversion-focused web design",
  "Landing pages",
  "Lead-generation funnels",
  "Online booking",
  "CRM integration",
  "Automated follow-up",
  "Analytics and tracking",
  "AI chat integration",
];

export default function WebInfra() {
  const navigate = useNavigate();
  return (
    <section id="web" data-testid="web-section" className="border-t border-line bg-surface px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto grid max-w-[1600px] gap-16 lg:grid-cols-2">
        <div>
          <Reveal><Overline>06 — Website &amp; Digital Infrastructure</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl">
              Your website should be part of <span className="text-zinc-500">your sales team.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-lg text-base leading-relaxed text-zinc-400 md:text-lg">
              TPA builds websites designed to do more than look good. Web experiences should
              help visitors understand the offer, establish trust, capture leads, and move
              prospects toward the next step.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <button
              data-testid="web-build-infra-btn"
              onClick={() => navigate("/book")}
              className="mt-12 bg-white px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.15em] text-black transition-colors duration-300 hover:bg-crimson hover:text-white"
            >
              Build Your Digital Infrastructure
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <ul className="grid grid-cols-1 gap-px bg-line sm:grid-cols-2">
            {CAPS.map((c) => (
              <li
                key={c}
                data-testid={`web-cap-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group flex items-center gap-4 bg-surface px-6 py-6 transition-colors duration-500 hover:bg-white/[0.04]"
              >
                <Check size={16} className="shrink-0 text-crimson" />
                <span className="font-display text-sm font-bold uppercase tracking-wide text-zinc-300 transition-colors duration-300 group-hover:text-white">{c}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
